import { useEffect } from 'react';
import type { URLOpenListenerEvent } from '@capacitor/app';
import { App } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import { alertModal } from './confirmation';
import { openInExternalUrl } from './utils';

const useAppUrlListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let urlOpenListener: PluginListenerHandle | null = null;

    const setupListeners = async () => {
      urlOpenListener = await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        //alertModal(`useAppUrlListener clicked: ${JSON.stringify(event)}`);
        console.warn('App opened with URL:', event?.url);

        try {
          // Handle different URL formats
          let targetPath = '';

          // Check if it's a full URL (https://tennistalker.it/path)
          if (event.url.includes('tennistalker.it')) {
            const slug = event.url.split('tennistalker.it').pop();
            if (slug && slug !== '/') {
              targetPath = slug;
            }
          }

          // Handle custom scheme (tennistalker://path)
          else if (event.url.startsWith('tennistalker://')) {
            const path = event.url.replace('tennistalker://', '');
            if (path && path !== '') {
              targetPath = path.startsWith('/') ? path : `/${path}`;
            }
          }
          // Direct path (just "/profilo")
          else if (event.url.startsWith('/')) {
            targetPath = event.url;
          }
          // If it's a full URL not tennistalker.it, open it in an external browser
          else if (event.url.startsWith('https://') || event.url.startsWith('http://')) {
            openInExternalUrl(event.url);
          }

          // Navigate to the extracted path
          if (targetPath && targetPath !== '/') {
            console.warn('Navigating to:', targetPath);
            navigate(targetPath);
          } else {
            alertModal(`no valid path found in URL: ${event.url} -> ${targetPath}`);
            console.warn('No valid path found, navigating to home');
            navigate('/');
          }
        } catch (error) {
          alertModal(`Error processing deep link: ${JSON.stringify(error)}`);
          console.error('Error processing deep link:', error);
          console.warn('Fallback: navigating to home');
          navigate('/');
        }
      });
    };
    if (Capacitor.isNativePlatform()) {
      setupListeners();
    }
    return () => {
      urlOpenListener?.remove();
    };
    // eslint-disable-next-line
  }, []);
};

export default useAppUrlListener;
